"use client";

import React from "react";
import { FilterOption, FilterSidebar } from "./filter-sidebar";

export interface MobileFilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
  filters: FilterOption;
  filterOptions: {
    therapyType?: string[];
    languages?: string[];
    areasOfFocus: Record<string, string[]>;
    provinces: string[];
    therapistTier?: string[];
    availability: string[];
    serviceFormat?: string[];
    modalities: string[];
  };
  focusSearchTerm: string;
  setFocusSearchTerm: (term: string) => void;
  toggleFilter: (category: keyof FilterOption, value: string) => void;
  activeFilterCount: number;
  onClearAll: () => void;
}

export function MobileFilterPanel({
  isOpen,
  onClose,
  filters,
  filterOptions,
  focusSearchTerm,
  setFocusSearchTerm,
  toggleFilter,
  activeFilterCount,
  onClearAll
}: MobileFilterPanelProps) {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Slide-out panel */}
      <div className={`fixed inset-y-0 left-0 w-full max-w-sm bg-white z-50 transform transition-transform duration-300 lg:hidden ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="p-4 border-b border-gray-200 flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">Find Your Match</h2>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors text-gray-700"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Filter content */}
          <div className="flex-1 overflow-y-auto p-4">
            <FilterSidebar
              filters={filters}
              filterOptions={filterOptions}
              focusSearchTerm={focusSearchTerm}
              setFocusSearchTerm={setFocusSearchTerm}
              toggleFilter={toggleFilter}
              activeFilterCount={activeFilterCount}
              onClearAll={onClearAll}
            />
          </div>
        </div>
      </div>
    </>
  );
}